import React from "react";

import { GameTitle, GameDescription } from "./DetailHeader.styled";

function DetailHeader({ title, description }) {
  return (
    <>
      <GameTitle>{title}</GameTitle>
      {/* <GameDescription>{description}</GameDescription> */}
    </>
  );
}

export default DetailHeader;
